import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import parse from "html-react-parser";
import { useHistory } from 'react-router-dom';
import 'react-notifications-component/dist/theme.css';
import { Col, Row, CardLink } from "reactstrap";
import { bibleAction } from '../../actions/bibleAction';
import { languageAction } from '../../actions/languageAction';
import { DABButton, DABDropDown, DABHtmlEditor, DABTextBox, DABBackToList, LoadingSpinnerModal } from '../../components/dab';
import { showAlert } from "../common/functions";

interface IBibleProps {
	dispatch: Dispatch<any>;
	bibleData: any;
	callback: any;
	id: number;
	languageData: any;
}

const BibleDetail: React.SFC<IBibleProps> = ({
	dispatch, bibleData, languageData, callback, id }) => {
	var biblesInput = {
		title: "",
		uniqueCode: "",
		descriptionHtml: "",
		languageCode: "",
		migrationKey: "",
		language: ""
	}

	const history = useHistory();

	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [isLangListLoaded, setIsLangListLoaded] = useState(false);
	const [formSubmit, setformSubmit] = useState(false);
	const [content, setContent] = useState("");
	const [bibleId, setBibleId] = useState(-1);
	const [languageName, setLanguageName] = useState("");
	const [isPreviewPage, setIsPreviewPage] = useState(false);
	const [input, setInput] = useState(biblesInput);
	const [showModal, setShowModal] = useState(false);
	const [isDetailLoaded, setIsDetailLoaded] = useState(false);
	const initialLangObject = [{ text: "English", value: "en", checked: false }];
	const [langList, setLangList] = useState(initialLangObject);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);

	const handleHtmlContentChange = (evt) => {
		setContent(evt.getData());
		setIsDirty(true)
	}

	const handleLanguageChange = (event) => {
		langList && langList.forEach((data: any) => {
			if (data.value === event.target.value) {
				setLanguageName(data.text);
			}
		});
	}

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (name === '') { return; }
		setInput({
			...input,
			[name]: value
		});
		setIsDirty(true)
	};

	const handleNextClick = (event) => {
		event.preventDefault();
		if (!isPreviewPage) {
			setIsPreviewPage(true);
			callback("Review Create New");
		}
		else if (isPreviewPage) {
			handleSubmit(event);
		}
	}

	const handleBackClick = (event) => {
		event.preventDefault();
		if (isPreviewPage) {
			setIsPreviewPage(false);
		}
		else if (!isPreviewPage) {
			history.goBack();
		}
	}

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		var inp = input;
		inp.descriptionHtml = content;
		setformSubmit(true);
		setShowModal(true);
		dispatch(bibleAction.bibleSave({ bible: inp }));
		setIsErrorOnPage(false);
	};

	React.useEffect(() => {
		if (!isLangListLoaded) {
			dispatch(languageAction.languageGetByfilter());
		}

		if (id >= 0) {
			dispatch(bibleAction.bibleGetDetail(id));
		}

		setShowModal(true);
	}, []);

	if (langList && !isLangListLoaded) {
		if (languageData.items.length > 0) {
			var list: any[] = [];
			languageData.items.sort((a: any, b: any) => a.name?.localeCompare(b.name)).forEach((data) => {
				var item = { text: data.name + " (" + data.languageCode + ")", value: data.languageCode, checked: true };
				list.push(item);
			});
			setLangList(list);
			setLanguageName(langList[0].text);

			setInput({
				...input,
				languageCode: langList[0].value
			});
			setIsLangListLoaded(true);
			setShowModal(false);
		}
	}

	if (bibleData) {
		if (bibleData.isError && !isErrorOnPage && !bibleData.isSuccess) {
			if (showModal) { setShowModal(false); }
			if (bibleData.status === 'Unauthorized') {
				history.push("/401");
			} else {
				showAlert(bibleData.status, true);
			}
			bibleData.isError=false
			setIsErrorOnPage(true);
		}

		if (formSubmit && bibleData.isSuccess && !bibleData.isError) {
			window.localStorage.setItem('alertMessage', bibleData.status);
			window.location.href = '/bible';
		}

		if (bibleData.isDetailComplete && isLangListLoaded) {
			if (!isDetailLoaded && bibleData.biblesInput) {
				setInput(bibleData.biblesInput);
				setContent(bibleData.biblesInput.descriptionHtml);
				callback(bibleData.biblesInput.title);
				setBibleId(bibleData.biblesInput.bibleId);
				setIsDetailLoaded(true);
			}
			if (showModal) {
				setShowModal(false);
			}
		}
	}

	const handleReadingList = (bibleId: number) => {
		localStorage.setItem("bibleId", JSON.stringify(bibleId));
		window.location.href = "/reading";
	};

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	return (
		<div className="bible-detail">
			{showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />)}
			<div className={['card-box'].join(" ")}>
				{!isDetailLoaded && !isPreviewPage && (
					<form name="createform" onSubmit={handleNextClick} className="create-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="languageCode" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div data-testid="languageContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown type="select" id="languageCode" onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} value={input.languageCode} options={langList} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}>Code</label>
							<div data-testid="uniqueCodeContainer" className={["col-sm-5"].join(" ")} >
								<DABTextBox id="uniqueCode" isRequired={true} onChange={(event) => { handleInputChange(event) }} value={input.uniqueCode} maxLength={50}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div data-testid="titleContainer" className={["col-sm-5"].join(" ")} >
								<DABTextBox id="title" isRequired={true} onChange={(event) => { handleInputChange(event) }} value={input.title} maxLength={50} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")}>Notes</label>
							<div data-testid="notesContainer" className={["col-sm-5"].join(" ")}>
								<DABHtmlEditor content={content} onChange={handleHtmlContentChange} id="description" />
							</div>
						</div>
						<Row className="bd-buttons">
							<Col lg="2" data-testid="bibleCancelButton">
								<DABButton id="cancel"  value="CANCEL" className="" onClick={(e) => { handleBackClick(e); }}></DABButton>
							</Col>
							<Col lg="2" data-testid="nextButtonContainer">
								<DABButton id="submit" className="btn-submit-frm" value="NEXT"></DABButton>
							</Col>
						</Row>
					</form>)}

				{isPreviewPage && !isDetailLoaded && (
					<div style={{ display: `${isPreviewPage ? '' : 'none'}` }} className="preview-form">
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="language" className={["col-sm-2 col-form-label"].join(" ")}>Language</label>
							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevLanguage">
								{languageName}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")}>Code</label>
							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevCode">
								{input.uniqueCode}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")}>Title</label>
							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevTitle">
								{input.title}
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")}>Notes</label>
							<div className={["col-sm-5 col-form-label-value"].join(" ")} data-testid="prevNote">
								{parse(content)}
							</div>
						</div>
						<Row className="bd-buttons">
							<Col lg="2">
								<DABButton id="back" value="BACK" onClick={(e) => { handleBackClick(e); }}></DABButton>
							</Col>
							<Col lg="2" data-testid="createButtonContainer">
								<DABButton value="CREATE" id="create" className="btn-submit-frm" onClick={(e) => { handleNextClick(e); }}></DABButton>
							</Col>
						</Row>
					</div>
				)}

				{isDetailLoaded && (
					<form name="createformEdit" onSubmit={handleSubmit} className="update-form">
						<DABBackToList onClick={(e) => { handleBackClick(e); }} />
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="uniqueCode" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblCodeContainer">Code</label>
							<div data-testid="uniqueCodeContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox id="uniqueCode" isRequired={true} onChange={(event) => { handleInputChange(event) }} value={input.uniqueCode} isHover={true} maxLength={50}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="language" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lbllanguageContainer">Language</label>
							<div data-testid="languageContainer" className={["col-sm-5"].join(" ")}>
								<DABDropDown type="select" id="languageCode" onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} value={input.languageCode} options={langList} isHover={true} />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="title" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblTitleContainer">Title</label>
							<div data-testid="titleContainer" className={["col-sm-5"].join(" ")}>
								<DABTextBox id="title" isRequired={true} onChange={(event) => { handleInputChange(event) }} value={input.title} isHover={true} maxLength={50}/>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="readings" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblReading">Readings</label>
							<div className={["col-sm-5 text-field"].join(" ")} data-testid="bibleViewReading">
							<CardLink onMouseDown={() => handleReadingList(bibleId) }  className='card-box-link-back' >
									View Readings
								</CardLink>
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblNotes" >Notes</label>
							<div data-testid="notesContainer" className={["col-sm-5"].join(" ")}>
								<DABHtmlEditor content={content} onChange={handleHtmlContentChange} id="description" />
							</div>
						</div>
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="migrationKey" className={["col-sm-2 col-form-label"].join(" ")} data-testid="lblMigrationKey" >Migration Key</label>							
							<div className={["col-sm-5 text-field"].join(" ")} style={{ paddingTop: "7px" }}>
								{input.migrationKey}
							</div>
								
						</div>
						<Row className="bd-buttons">
							<Col data-testid="saveChangesButtonContainer" lg="12" className={["pull-right"].join(" ")}>
								<DABButton id="submit" value="SAVE CHANGES" className="btn-submit-frm"></DABButton>
							</Col>
						</Row>						
					</form>
						
				)}
				
				<Row >
					<Col lg="12">
						{formSubmit && bibleData.isSuccess && bibleData.error && (
							<div className="alert alert-dismissible alert-danger">
								{bibleData.status}
							</div>
						)}
					</Col>
				</Row>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { bibleData, languageData } = state;
	return {
		bibleData, languageData
	};
};

export default connect(mapStateToProps)(BibleDetail);